/** 智能人事列表枚举展示文案（仅 UI；接口/库仍存英文码） */
export function sourceText (code) {
  if (code === 'LOCAL') return '本地'
  if (code === 'DING') return '钉钉'
  return code || '—'
}

export function onboardingStatusText (code) {
  if (code === 'PENDING' || code === 'WAIT') return '待入职'
  if (code === 'DONE') return '已入职'
  if (code === 'CANCEL') return '已取消'
  return code || '—'
}

export function regularizationStatusText (code) {
  if (code === 'DRAFT') return '草稿'
  if (code === 'OPEN') return '待转正'
  if (code === 'DONE') return '已办'
  if (code === 'CANCEL') return '已取消'
  return code || '—'
}

export function transferStatusText (code) {
  if (code === 'DRAFT') return '草稿'
  if (code === 'OPEN') return '办理中'
  if (code === 'DONE') return '已办结'
  if (code === 'CANCEL') return '已取消'
  return code || '—'
}

export function resignationStatusText (code) {
  if (code === 'DRAFT') return '草稿'
  if (code === 'OPEN') return '办理中'
  if (code === 'DONE') return '已离职'
  if (code === 'CANCEL') return '已取消'
  return code || '—'
}

export function processTypeText (code) {
  if (code === 'REGULAR') return '转正'
  if (code === 'TRANSFER') return '调岗'
  if (code === 'RESIGN') return '离职'
  return code || '—'
}



// WEBPACK FOOTER //
// ./src/components/smartHr/enumLabels.js